import api from '../../../services/apiConfig';

export interface ProductAnalysisData {
    Produto: string;
    Linha: string;
    Descricao: string;
    QuantidadeTotal: number;
    FaturamentoTotal: number;
    MargemTotal: number;
    MargemPercentual: number;
    PrecoMedio: number;
    NumClientes: number;
}

// 1.(Parâmetros da Tabela)
export interface ProductAnalysisParams {
    dataI: string;
    dataF: string;
    carteiraId?: string;
    page: number;
    limit: number;
    sortKey: string;
    sortOrder: string;
    filterProduto: string;
    filterLinha: string;
    clientId?: number;
    refresh?: boolean;
}

// 2.(Resposta da Tabela)
export interface ProductAnalysisResponse {
    productData: ProductAnalysisData[];
    totalItems: number;
    cached?: boolean;
    cachedAt?: string;
}

// Interface genérica para uma resposta de sucesso da API
interface ApiSuccessResponse<T> {
    success: true;
    data: T;
}

// Interface para uma resposta de erro da API
interface ApiErrorResponse {
    success: false;
    error: string;
}

type ApiResponse<T> = ApiSuccessResponse<T> | ApiErrorResponse;

export interface ProductCustomer {
    NomeCliente: string;
    FaturamentoTotal: number;
    QuantidadeTotal: number;
}

export interface ProductExtraDetails {
    CA: string;
    DESCRICAO: string;
    img?: string | null;
}

export interface ProductTrendPoint {
    date: string;
    value: number;
}

export interface ProductTrendResponse {
    trends: {
        [productLine: string]: ProductTrendPoint[];
    };
}

export interface TopLineData {
    Linha: string;
    QuantidadeTotal: number;
    FaturamentoTotal: number;
}

export interface LineCompositionData {
    Linha: string;
    Referencia: string;
    Faturamento: number;
    Quantidade: number;
}

// Interface para os parâmetros (assumindo que são os mesmos)
interface DateRangeParams {
    dataI: string;
    dataF: string;
    carteiraId?: string;
    clientId?: number;
}

// Corresponde a: GET /api/products/analysis
export const fetchProductAnalysis = (params: ProductAnalysisParams) => {
    // Retorna a resposta completa (productData + totalItems)
    return api.get<ProductAnalysisResponse>('/products/analysis', { params });
};

// Corresponde a: GET /api/products/trends
export const fetchProductTrends = (params: DateRangeParams) => {
    return api.get('/products/trends', { params });
};

// Corresponde a: GET /api/products/customers/:productRef
export const fetchProductCustomers = (productRef: string, params: DateRangeParams) => {
    return api.get(`/products/customers/${encodeURIComponent(productRef)}`, { params });
};

// Corresponde a: GET /api/products/details/:productRef
export const fetchProductDetails = (productRef: string) => {
    return api.get(`/products/details/${encodeURIComponent(productRef)}`);
};

export const fetchTopLinesByQuantity = async (params: { dataI: string, dataF: string, carteiraId?: string, clientId?: number }): Promise<ApiResponse<{ topLines: TopLineData[] }>> => {
    try {
        const response = await api.get('/products/top-lines-quantity', { params });
        return { success: true, data: response.data };
    } catch (error: any) {
        return { success: false, error: error.response?.data?.error || 'Erro desconhecido' };
    }
};

export const fetchLineCompositionRevenue = async (params: { dataI: string, dataF: string, carteiraId?: string, clientId?: number }): Promise<ApiResponse<{ lineComposition: LineCompositionData[] }>> => {
    try {
        const response = await api.get('/products/line-composition-revenue', { params });
        return { success: true, data: response.data };
    } catch (error: any) {
        return { success: false, error: error.response?.data?.error || 'Erro desconhecido' };
    }
};